import { DASHBOARD_DIRECTORY_PAGE } from '@townsquare/config/routes';
import { DASHBOARDS_PATH } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';
import { GlobalHomePageRoute } from '@townsquare/router/route-types';

export const dashboardDirectoryRoute: GlobalHomePageRoute = createGlobalRoute({
	exact: true,
	name: DASHBOARD_DIRECTORY_PAGE,
	path: DASHBOARDS_PATH,
});
